import { OperatorFunction } from 'rxjs';
import { buffer, debounceTime, endWith, ignoreElements, takeUntil } from 'rxjs/operators';

type BufferDebounceTime = <T>(debounceMilliSeconds: number) => OperatorFunction<T, T[]>;

export const bufferDebounceTime: BufferDebounceTime = debounceMilliSeconds => source => {
  const bufferEmitNotifier = source.pipe(
    debounceTime(debounceMilliSeconds)
  );
  return source.pipe(
    buffer(bufferEmitNotifier),
    takeUntil(bufferEmitNotifier.pipe(ignoreElements(), endWith(true)))
  );
};
